import { PersonBonus, DataVehicles, BonusCampaign } from '@esportal/portal-service';
import {
	HuchaDisclaimer1Text,
	HuchaDisclaimer2Text,
} from '../../components/benefits/hucha/components/disclaimers/hucha-disclaimers';
import { NamedDisclaimer } from './disclaimers-utils';
import {
	AlertDisclaimerText1,
	AlertDisclaimerText2,
	findBonusAlert,
	noVehicleOrder2025,
} from './alert-disclaimers-utils';

export const getAllDisclaimers = (
	personBonus: PersonBonus | null,
	vehicles: DataVehicles | null,
): NamedDisclaimer[] => {
	if (!vehicles || !personBonus) return [];

	const textToIndexMap = new Map();
	const disclaimers: NamedDisclaimer[] = [];
	let uniqueIndex = 1;

	let bonusDisclaimers: string[] = [];
	let alertsDisclaimers: string[] = [];

	// add hucha disclaimers text
	const huchaDisclaimers: string[] = [HuchaDisclaimer1Text, HuchaDisclaimer2Text];

	// add alerts disclaimers text
	if (noVehicleOrder2025(vehicles) && !findBonusAlert(BonusCampaign.IDWeChargePostPedido, personBonus)) {
		alertsDisclaimers.push(AlertDisclaimerText1);
	}

	if (findBonusAlert(BonusCampaign.IDWeChargePostPedido, personBonus)) {
		alertsDisclaimers.push(AlertDisclaimerText2);
	}

	// add bonus disclaimers text
	personBonus.bonus
		.filter((b) => b.legalText && b.legalText.trim())
		.forEach((b) => {
			const processedText = b.legalText
				.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
				.replace(/__(.*?)__/g, '<u>$1</u>');
			bonusDisclaimers.push(processedText);
		});

	const allDisclaimersText: string[] = [...bonusDisclaimers, ...alertsDisclaimers, ...huchaDisclaimers];

	allDisclaimersText.forEach((text) => {
		if (!textToIndexMap.has(text)) {
			textToIndexMap.set(text, uniqueIndex);
			disclaimers.push({
				ref: `${uniqueIndex}.`,
				text,
			});
			uniqueIndex++;
		}
	});

	return disclaimers;
};
